module.exports = {"511781001":"古东关街道","511781100":"太平镇","511781101":"青花镇","511781102":"旧院镇","511781103":"罗文镇","511781104":"河口镇","511781105":"草坝镇","511781106":"竹峪镇","511781107":"大竹镇","511781108":"黄钟镇","511781109":"官渡镇","511781110":"白沙镇","511781111":"沙滩镇","511781112":"石窝镇","511781113":"八台镇","511781114":"石塘镇","511781115":"铁矿镇","511781116":"大沙镇","511781117":"魏家镇","511781118":"白果镇","511781119":"长坝镇","511781120":"井溪镇","511781121":"鹰背镇","511781123":"永宁镇","511781124":"固军镇","511781125":"黑宝山镇","511781207":"蜂桶乡","511781210":"曾家乡","511781216":"玉带乡","511781226":"庙子乡","511781228":"紫溪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511781.json
// module id = 2510
// module chunks = 0